const CartItem = require('./CartItem');
const Events = require('../../util/events');

/**
 * Events:
 *      add
 *      remove
 */



const Cart = function() {
    this.items = {};
    this.__events = new Events();
};

Cart.prototype = {
    constructor: Cart,
    items: undefined,
    __events: undefined,
    on: function(names, cb) { this.__events.on(names, cb); },
    off: function(names, cb) { this.__events.off(names, cb); },
    addItem: function(props) {
        // tmp
        var tmp = new CartItem(props);

        // existing
        var existing = this.findItem(tmp.uid());

        //
        var item = existing ? existing : tmp;

        if (existing) {
            item.quantity += tmp.quantity;
            this.__events.fire('add', { caller: this, item: item, uid: item.uid(), existing: true });
        }
        else {
            this.items[item.uid()] = item;
            this.__events.fire('add', { caller: this, item: item, uid: item.uid(), existing: false });
        }
    },
    removeItem: function(uid, props) {
        var existing = this.findItem(uid, props);
        if (existing) {
            var uid = existing.uid();
            delete this.items[uid];
            this.__events.fire('remove', { caller: this, item: existing, uid: uid });
            return true;
        }
        return false;
    },
    removeGroup: function(gid) {
        var self = this,
            type = gid.match(/^[^_]+/)[0],
            id = gid.match(/_(\d+)$/)[1],
            items = this.group(type, id);
        items.items.forEach(item => self.removeItem(item.uid()));
    },
    findItem: function(uid, props) {
        if (!uid && props) {
            // tmp cart item
            var tmp = new CartItem(props);
            uid = tmp.uid();
        }
        if (this.items.hasOwnProperty(uid)) {
            return this.items[uid];
        }
    },
    findById: function(id, type) {
        var self = this,
            list = {};
        Object.keys(this.items).forEach(function(key) {
            // console.log(id, key, self.items[key]);
            if (self.items[key].id == id) {
                if (type && self.items[key].type === type) {
                    list[key] = self.items[key];
                }
                else if (!type) {
                    list[key] = self.items[key];
                }
            }
        });
        return list;
    },
    filter: function(props) {
        var matches = {};
        Object.values(this.items).forEach((item) => {
            var match = true;
            Object.keys(props).forEach(key => {
                if (item[key] != props[key]) {
                    match = false;
                }
            })
            if (match) {
                matches[item.uid()] = item;
            }
        });
        return matches;
    },
    group: function(type, id) {
        var quantity, items;

        // get items
        items = Object.values(this.filter({ type: type, id: id }));
        quantity = items.reduce((qty, item) => qty + item.quantity, 0);

        if (!items.length) return null;

        var data = items[0].export();
        data.quantity = quantity;
        delete data.modkey;
        data.groupId = items[0].groupId();

        data.items = items;

        return data;
    },
    export: function() {
        return this.items;
    },
    exportArray: function() {
        var arr = [];
        for (var key in this.items) {
            if (this.items.hasOwnProperty(key)) {
                arr.push(this.items[key].export());
            }
        }
        return arr;
    }
};

module.exports = Cart;